export const SET_COVER_FROM = {
  CAPTURE_VIDEO_FRAME: 'CAPTURE_VIDEO_FRAME',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE'
}
